import { Button, Selector } from '@casumo/dojo-react';
import { memo } from 'react';
import { useRegistrationStore } from '../store/store.ts';
import { TDepositTypeSelectorField } from '../types/types.ts';

const DepositTypeSelector = ({ name, label, options }: TDepositTypeSelectorField) => {
  const { metadata, setMetadata } = useRegistrationStore();

  return (
    <div className="flex flex-col gap-xs">
      <Selector name="depositType">
        {options?.map(({ value, label }, idx) => (
          <Selector.Radio
            checked={value === metadata?.depositType || idx === 0}
            className="flex justify-center w-full"
            value={value}
            key={value}
            readOnly
            onClick={() => setMetadata({ [name]: value })}>
            {label}
          </Selector.Radio>
        ))}
      </Selector>
      <Button className="w-full" onClick={() => console.info(`Redirect to ${metadata?.depositType}`)}>
        {label} {options?.find(option => option.value === metadata?.depositType)?.label || options?.[0].label}
      </Button>
    </div>
  );
};

const Memoized = memo(DepositTypeSelector);
Memoized.displayName = 'DepositTypeSelector';

export default Memoized;
